<template lang="pug">
  .bottomBar
    .tabBarList
      nuxt-link.tabBarItem(to="/tv-vendas")
        i.material-icons ondemand_video
        span TV Vendas
      nuxt-link.tabBarItem(to="/menu")
        IcoMenu
        span Menu
      nuxt-link.tabBarItem(
        to="/coaching"
        v-if="user.jobTitle !== 'Vendedor' && !isConsultant"
      )
        IcoCoaching.icoCoaching
        span Coaching
      nuxt-link.tabBarItem(to="/notificacoes")
        div.notification-container
          span(v-if="unseenNotifications.length > 0") {{ unseenNotifications.length }}
          i.material-icons notifications
        span Notificações
</template>

<script>
import { mapActions, mapState } from 'vuex'
import IcoCoaching from '~/components/icons/IcoCoaching'
import IcoGame from '~/components/icons/IcoGame'
import IcoHome from '~/components/icons/IcoHome'
import IcoMenu from '~/components/icons/IcoMenu'

export default {
  name: 'TheBottomTabBar',
  components: {
    IcoMenu,
    IcoGame,
    IcoCoaching,
    IcoHome,
  },
  computed: {
    ...mapState({
      notifications: state => state.notification.notifications,
    }),
    user() {
      return this.$store.state.layout.user
    },
    isConsultant() {
      const { consultantFor, jobTitle, isConsultantManager } = this.user
      return (
        (!!consultantFor?.length || isConsultantManager) &&
        jobTitle === 'Empresa'
      )
    },
    unseenNotifications() {
      const notifications = Object.values(this.notifications)
      return notifications.flatMap(item => item).filter(item => !item.seen)
    },
  },
  async created() {
    this.getNotifications()
  },
  methods: {
    ...mapActions('notification', ['getNotifications']),
  },
}
</script>

<style lang="sass" scoped>
.bottomBar
  background-color: var(--primaryColor)
  border-radius: 8px 8px 0 0
  position: fixed
  bottom: 0
  width: 100vw
  height: 60px
  z-index: 2001 // Maior que o index do componente que indica carregamento (v-loading)
  transition: filter .7s
  filter: saturate(1)
  body.offline &
    filter: saturate(0)
.tabBarList
  display: flex
  justify-content: space-around
  height: 78%
  align-items: flex-end
.tabBarItem
  color: #FFFFFF
  display: flex
  flex-direction: column
  text:
    align: center
    decoration: none
    transform: uppercase
  & > *
    display: block
  span
    font:
      size: .5em
      weight: 100
  svg
    fill: #fff
    width: auto
    height: 16px
    margin-bottom: 5px
    &.icoCoaching
      height: 20px
.notification-container
  position: relative
  span
    position: absolute
    top: -8px
    right: 10px
    min-width: 15px
    min-height: 15px
    padding: 2px
    border-radius: 17px
    display: flex
    align-items: center
    justify-content: center
    font-size: .8rem
    font-weight: bold
    background: white
    color: var(--primaryColor)
</style>
